import { render, staticRenderFns } from "./CalendarItemCard.vue?vue&type=template&id=4525d6c4&scoped=true&"
import script from "./CalendarItemCard.vue?vue&type=script&lang=js&"
export * from "./CalendarItemCard.vue?vue&type=script&lang=js&"
import style0 from "./CalendarItemCard.vue?vue&type=style&index=0&id=4525d6c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4525d6c4",
  null
  
)

export default component.exports